export const StudentRefferalData = [
  {
    id:"1",
    Referred_ID: "#REF010",
    Referrals: "Thompson Hicks",
    image:"user-01.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \n refid=345re667877k960",
    FIELD4: "",
    Visits: 10,
    Total_Earned: "$160",
  },
  {
    id:"2",
    Referred_ID: "#REF009",
    Referrals: "Jennifer Tovar",
    image:"user-06.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 8,
    Total_Earned: "$180",
  },
  {
    id:"3",
    Referred_ID: "#REF008",
    Referrals: "James Schulte",
    image:"user-09.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 12,
    Total_Earned: "$200",
  },
  {
    id:"4",
    Referred_ID: "#REF007",
    Referrals: "Kristy Cardona",
    image:"user-20.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 17,
    Total_Earned: "$220",
  },
  {
    id:"5",
    Referred_ID: "#REF006",
    Referrals: "William Aragon",
    image:"user-27.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 9,
    Total_Earned: "$170",
  },
  {
    id:"6",
    Referred_ID: "#REF005",
    Referrals: "Shirley Lis",
    image:"user-30.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 15,
    Total_Earned: "$150",
  },
  {
    id:"7",
    Referred_ID: "#REF004",
    Referrals: "John Brewer",
    image:"user-17.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 13,
    Total_Earned: "$130",
  },
  {
    id:"8",
    Referred_ID: "#REF003",
    Referrals: "Doris Hughes",
    image:"user-37.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 17,
    Total_Earned: "$190",
  },
  {
    id:"9",
    Referred_ID: "#REF002",
    Referrals: "Sarah Martinez",
    image:"user-04.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 8,
    Total_Earned: "$140",
  },
  {
    id:"10",
    Referred_ID: "#REF001",
    Referrals: "Sarah Martinez",
    image:"user-18.jpg",
    URL: "$1https://dreamslmscourse.com/reffer/? \nrefid=345re667877k960",
    FIELD4: "",
    Visits: 11,
    Total_Earned: "$110",
  },
];
